module.exports = __webpack_public_path__ + "static/media/42x38-15.58376366.png";